import type { App } from 'vue'

import { createPinia } from 'pinia'
import { createPersistedState } from 'pinia-plugin-persistedstate'

import {
  useBundleStore,
  useCartStore,
  useThemeStore,
  useReferralStore
} from '@/stores'

declare module '@vue/runtime-core' {
  interface ComponentCustomProperties {
    $bundle: ReturnType<typeof useBundleStore>
    $cart: ReturnType<typeof useCartStore>
    $theme: ReturnType<typeof useThemeStore>
    $referral: ReturnType<typeof useReferralStore>
  }
}

export const piniaPlugin = {
  install(app: App) {
    // Setup pinia plugin
    const pinia = createPinia()
    pinia.use(createPersistedState())
    app.use(pinia)

    // Init stores
    const theme = useThemeStore()
    const bundle = useBundleStore()
    const cart = useCartStore()
    const referral = useReferralStore()

    app.config.globalProperties.$bundle = bundle
    app.config.globalProperties.$cart = cart
    app.config.globalProperties.$theme = theme
    app.config.globalProperties.$referral = referral

    cart.load()
  }
}

export default piniaPlugin
